import { connect } from 'react-redux';
import {
    FrameworkActionCreator, ICustomerState,
    CustomerActionCreator, IAppointmentState, ISpecsState, AppointmentActionCreator,
} from 'src/store/states';
import OEMCustSearch from 'src/components/OEMCustSearch/OEMCustSearch';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: ICustomerState & IAppointmentState & IStoreState & ISpecsState) => ({
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    apptCust: state.Appointment.ApptCust,
    custInfo: state.Customer!['Customer'],
    errMsg: state.Customer.errMsg,
    loading: state.Customer.loading,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    theme: state.Framework.theme,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    spmCustomerCentral: CustomerActionCreator.OEMCustomerSearch,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    clearError: CustomerActionCreator.CustomerClearError,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OEMCustSearch);